import { useState } from "react";
import { LOGO_URL, HERO_BG } from "../lib/config";
import { Button } from "./ui/button";

export default function AgeGate({ onVerify }) {
    const [denied, setDenied] = useState(false);

    if (denied) {
        return (
            <div
                data-testid="age-gate-denied"
                className="fixed inset-0 z-[100] flex items-center justify-center bg-black"
            >
                <div className="max-w-md text-center px-6">
                    <h1 className="text-3xl font-display font-bold text-white mb-4">
                        Sorry, you must be 21 or older.
                    </h1>
                    <p className="text-white/60">
                        Come back when you've reached the legal age. Drive safe.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div
            data-testid="age-gate-modal"
            className="fixed inset-0 z-[100] flex items-center justify-center px-4"
            style={{
                backgroundImage: `linear-gradient(rgba(5,5,7,0.85), rgba(5,5,7,0.95)), url(${HERO_BG})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="glass relative max-w-lg w-full rounded-3xl p-8 sm:p-10 text-center grain overflow-hidden">
                <img
                    src={LOGO_URL}
                    alt="High 95"
                    className="w-24 h-24 mx-auto mb-6 rounded-2xl object-cover ring-1 ring-white/10 bg-white/5 p-2"
                />
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-highway-red mb-3">
                    Exit 21 Only
                </p>
                <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mb-4 text-balance">
                    Are you <span className="text-highway-red">21+</span>?
                </h1>
                <p className="text-white/70 mb-8 text-sm leading-relaxed">
                    By entering High95 you confirm that you are of legal age in
                    your state to purchase hemp-derived THCA products. We do not
                    sell to minors.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Button
                        data-testid="age-gate-yes"
                        onClick={onVerify}
                        className="rounded-full bg-highway-red hover:bg-highway-red/90 text-white px-8 py-6 text-base font-semibold glow-red"
                    >
                        I am 21 or older
                    </Button>
                    <Button
                        data-testid="age-gate-no"
                        onClick={() => setDenied(true)}
                        variant="ghost"
                        className="rounded-full border border-white/20 hover:bg-white/10 text-white px-8 py-6 text-base font-semibold"
                    >
                        Under 21
                    </Button>
                </div>
                <p className="font-mono text-[10px] uppercase tracking-widest text-white/40 mt-8">
                    South Jersey · Local Delivery Only
                </p>
            </div>
        </div>
    );
}
